@if (trigger(); as t) {
<p-card
    class="rounded-md border flex! flex-col! gap-3! cursor-pointer transition-colors duration-200 h-full"
    (click)="onCardClick()"
    [ngClass]="{
            'border-border opacity-60': !t.enabled,
            'border-border hover:border-border-strong': t.enabled,
            'border-red-500/60! hover:border-red-500!': !triggerValid()
        }">
    <div class="flex! justify-between items-center mb-2">
        @if (triggerValid()) {
        <div class="w-9 h-9 rounded-sm bg-brand-tint flex! items-center justify-center">
            <i class="ph ph-lightning text-brand text-xl"></i>
        </div>
        } @else {
        <div class="w-9 h-9 rounded-sm bg-concern-warn flex! items-center justify-center">
            <i class="ph ph-warning text-concern-warn-dot text-xl"></i>
        </div>
        }

        <p-toggleswitch
            [ngClass]="triggerValid() ? '' : 'invalidcheck'"
            [ngModel]="t.enabled"
            (ngModelChange)="onEnabledChange($event)"
            (click)="$event.stopPropagation()" />
    </div>
    <div class="mb-1">
        <p class="font-semibold text-sm text-text leading-snug">{{ t.name ? t.name : ('UNNAMED_TRIGGER' | translate) }}</p>
        <p class="text-xs text-text mt-0.5">{{ 'TRIGGER_' + t.triggerData.name | translate }}</p>
    </div>
    <section class="flex! gap-2 items-center">
        @if (t.actionData.name) {
        <p-tag severity="secondary" class="text-xs! w-fit!">{{ 'TRIGGER_ACTION_' + t.actionData.name | translate }}</p-tag>
        } @if (!triggerValid() && triggerErrorMessage().length) {
        <p-tag severity="danger" class="text-xs! w-fit">{{ triggerErrorMessage() | translate }}</p-tag>
        }
    </section>
</p-card>
}
